<template>
  <div id="app" :class="display.class">
    <div class="spinner-chart" v-if="display.loading"><i class="fa fa-spinner fa-pulse"></i></div>

    <hbarcustom v-if=display.hbarcustom :chartData="chartData" :opts="opts" :translations="translations"></hbarcustom>
    <matrix v-if=display.matrix :chartData="chartData" :opts="opts" :translations="translations"></matrix>
    <swiper v-if=display.swiper :chartData="chartData" :opts="opts" :translations="translations"></swiper>
    <ranking v-if=display.ranking :chartData="chartData" :opts="opts" :translations="translations"></ranking>
    <personality v-if=display.personality :chartData="chartData" :opts="opts" :translations="translations"></personality>
    <team-selector v-if=display.teamSelector :chartData="chartData" :opts="opts" :translations="translations"></team-selector>

    <Total v-if=display.total :chartData="chartData" :translations="translations"></Total>
  </div>
</template>

<script>
import Hbarcustom from './components/charts/HBarCustom'
import Total from './components/Total'
import Swiper from './components/charts/Swiper'
import Matrix from './components/charts/Matrix'
import Ranking from './components/charts/Ranking'
import Personality from './components/charts/Personality'
import TeamSelector from './components/charts/TeamSelector'
import { getChartData, getPersonalityChartData } from './helpers/http'
import { replaceVars } from './helpers/variables'
import { getTranslations } from './helpers/translations'
import {
  totalAndCheckForAnsweredData,
  totalAndCheckForAnsweredDataSwiper,
  totalAndCheckForMatrix
} from './helpers/total'

export default {
  name: 'App',
  props: ['dataAttributs'],
  components: {
    Total,
    Hbarcustom,
    Swiper,
    Matrix,
    Ranking,
    Personality,
    TeamSelector
  },
  data () {
    return {
      language: 'en',
      translations: {},
      display: {
        loading: true,
        total: false,
        hbarcustom: false,
        swiper: false,
        matrix: false,
        personality: false,
        ranking: false,
        teamSelector: false,
        class: ''
      },
      chartData: {
        chart: null,
        configuration: null
      },
      opts: null
    }
  },
  methods: {
    verifyChartType: function (r) {
      if (this.dataAttributs.showQuestion === 'true') {
        r.configuration.options.showQuestion = true
      }

      if (this.dataAttributs.showVotes === 'true') {
        r.configuration.options.showVotesByAnswer = true
      }

      if (this.dataAttributs.showIllustrations === 'true') {
        r.configuration.options.showIllustrations = true
      }

      if (this.dataAttributs.showTotal === 'true') {
        this.display.total = true
      } else {
        this.display.total = r.configuration.options.display && r.configuration.options.showTotalVotes
      }

      const displayChart = this.dataAttributs.display === 'true' || r.configuration.options.display

      switch (r.configuration.type) {
        case 'HBARCUSTOM':
          this.chartData = totalAndCheckForAnsweredData(r.chart, this.dataAttributs.answers)
          this.chartData = replaceVars(this.chartData, this.dataAttributs.variables)
          this.opts = r.configuration
          this.display.hbarcustom = displayChart
          break

        case 'SWIPER':
          this.chartData = totalAndCheckForAnsweredDataSwiper(r.chart, this.dataAttributs.answers)
          this.chartData = replaceVars(this.chartData, this.dataAttributs.variables)
          this.opts = r.configuration
          this.display.swiper = displayChart
          break

        case 'MATRIX':
          this.chartData = totalAndCheckForMatrix(r.chart)
          this.chartData = replaceVars(this.chartData, this.dataAttributs.variables)
          this.display.matrix = displayChart
          this.opts = r.configuration
          break

        case 'RANKING':
          this.chartData = totalAndCheckForAnsweredData(r.chart)
          this.chartData = replaceVars(this.chartData, this.dataAttributs.variables)
          this.display.ranking = displayChart
          this.opts = r.configuration
          break

        case 'PERSONALITY':
          this.chartData = totalAndCheckForAnsweredData(r.chart)
          this.chartData = replaceVars(this.chartData, this.dataAttributs.variables)
          r.configuration.options.showQuestion = false
          this.display.personality = displayChart
          this.display.total = false
          this.opts = r.configuration
          break

        case 'TEAM_SELECTOR':
          this.chartData = totalAndCheckForAnsweredData(r.chart, this.dataAttributs.answers)
          this.chartData = replaceVars(this.chartData, this.dataAttributs.variables)
          this.opts = r.configuration
          this.opts.options.showQuestion = false
          this.display.teamSelector = displayChart
          this.display.total = false
          break

        default:
          break
      }

      this.display.loading = false
    }
  },
  mounted () {
    let promise

    if (this.dataAttributs.classStyle) {
      this.display.class = this.dataAttributs.classStyle
    }

    if (this.dataAttributs && this.dataAttributs.questions) {
      promise = getPersonalityChartData(this.dataAttributs)
    } else {
      promise = getChartData(this.dataAttributs)
    }
    promise.then(r => this.verifyChartType(r.data))
      .catch(e => {
        console.log(e)
        this.display.loading = false
      })

    this.language = this.dataAttributs.language || 'en'
    this.translations = getTranslations(this.language)
  }
}
</script>

<style>

.spinner-chart .fa-spinner {
    position: absolute;
    font-size: 27px;
    opacity: 0.3;
    left: 50%;
    z-index: 1;
    top: 50%;
    margin-left: -15px;
    margin-top: -15px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue